import { useFileBrowserContext } from './Context'
import { FileUploader } from '@ztechapps/webui.input'
import { fieldConfig } from './FileList'
import { DataTool } from '../DataTool'

export const Toolbox = () => {
  const { fileListResult, onSetFileMeta } = useFileBrowserContext()
  return (
    <DataTool
      fieldsConfig={fieldConfig}
      {...{
        ...fileListResult,
        searchPlaceHolder: 'Search files',
        filterCategory: 'cacheStorageFilterCategory',
        components: {
          other: () => (
            <FileUploader
              onSetFileMeta={onSetFileMeta}
              onUploadComplete={async () => {
                fileListResult.refetch()
              }}
            />
          ),
        },
      }}
    />
  )
}
